import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
//Componentes
import { ComponentsModule } from './components/components.module';
import { HttpClientModule } from '@angular/common/http';

//Camara
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';

//Date picker
import { DatePicker } from '@ionic-native/date-picker/ngx';
import * as $ from "jquery";   
//DatePicker 2    
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

//Notificaciones Push
import { OneSignal } from '@ionic-native/onesignal/ngx';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule,
    HttpClientModule,
    ComponentsModule, 
    BrowserAnimationsModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    BarcodeScanner, 
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ], 
  bootstrap: [AppComponent]
})
export class AppModule {}
